module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "top-box"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("2020年全国啦啦操公开赛")]), _vm._v(" "), _c('van-dropdown-menu', [_c('van-dropdown-item', {
    scopedSlots: _vm._u([{
      key: "title",
      fn: function() {
        return [_c('p', {
          staticClass: "dropdown-item-title"
        }, [_vm._v(_vm._s(_vm.option[_vm.value].text))])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, [_vm._v(" "), _vm._l((_vm.option), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "dropdown-item",
      on: {
        "click": function($event) {
          return _vm.dropdownChange(item)
        }
      }
    }, [_c('p', {
      staticClass: "dropdown-item-option-title"
    }, [_vm._v(_vm._s(item.text))])])
  })], 2)], 1)], 1), _vm._v(" "), _vm._l((2), function(i) {
    return _c('div', {
      key: i,
      staticClass: "activity-list"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "list-team"
    }, [_vm._l((5), function(item, i) {
      return _c('div', {
        key: i,
        staticClass: "team-item"
      }, [_c('div', {
        staticClass: "team-rank"
      }, [(i < 3) ? _c('div', {
        class: 'team-rank-num rank-change' + i
      }, [_vm._v(_vm._s(i + 1) + ".")]) : _c('div', {
        staticClass: "team-rank-num rank-no"
      }, [_vm._v(_vm._s(i + 1))])]), _vm._v(" "), _vm._m(1, true)])
    }), _vm._v(" "), _c('div')], 2)])
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "activity-list-title-box"
  }, [_c('div', {
    staticClass: "title-left-solid"
  }), _vm._v(" "), _c('div', {
    staticClass: "activity-title"
  }, [_vm._v("公开幼儿乙组-舞蹈啦啦操-集体花球自选动作")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "team-info"
  }, [_c('div', {
    staticClass: "team-info-name"
  }, [_vm._v("广州华怡教育小麒麟啦啦队")]), _vm._v(" "), _c('div', {
    staticClass: "team-info-grande"
  }, [_vm._v("决赛 182分  预赛150分")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8002fdc0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/activity/QueryGrade.vue
// module id = 1295
// module chunks = 0